import React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const SIZE_CLASSES = {
  sm: "w-6 h-6",
  md: "w-8 h-8",
  lg: "w-16 h-16",
};

/** Renders the mark in the current theme primary color (PNG alpha as mask). */
const LOGO_MASK_STYLE = {
  WebkitMaskImage: "url(/terrakronos-logo.png)",
  maskImage: "url(/terrakronos-logo.png)",
  WebkitMaskSize: "contain",
  maskSize: "contain",
  WebkitMaskRepeat: "no-repeat",
  maskRepeat: "no-repeat",
  WebkitMaskPosition: "center",
  maskPosition: "center",
};

/**
 * @param {string} [className] - Tailwind classes for the mark (size)
 * @param {keyof SIZE_CLASSES} [size] - Preset size if className omitted (e.g. TC invite)
 * @param {string} [to] - When set, logo is a React Router link (e.g. "/dashboard")
 * @param {string} [wrapperClassName] - Extra classes on the link wrapper
 * @param {string} [ariaLabel] - Accessibility label when linked
 */
export function TerraLogo({
  className,
  size,
  to,
  wrapperClassName = "",
  ariaLabel = "Go to dashboard",
}) {
  const resolvedClass =
    className ?? (size ? SIZE_CLASSES[size] : undefined) ?? "w-6 h-6";

  const mark = (
    <span
      className={cn("inline-block shrink-0 bg-primary", resolvedClass)}
      style={LOGO_MASK_STYLE}
      {...(to
        ? { "aria-hidden": true }
        : { role: "img", "aria-label": "TerraKronos Logo" })}
    />
  );

  if (to) {
    return (
      <Link
        to={to}
        className={`inline-flex shrink-0 rounded-md hover:opacity-90 transition-opacity focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 ${wrapperClassName}`.trim()}
        aria-label={ariaLabel}
      >
        {mark}
      </Link>
    );
  }

  return mark;
}

export default TerraLogo;
